import {
  LOAN_APPLICATION_FETCH_SUCCESS,
  LOAN_APPLICATION_UPDATE_SUCCESS,
  PRIMARY_ENTERS_DATA_CHANGED,
  UPDATE_COMMITMENTS_SUCCESS,
  UPDATE_READYFORFINAL_SUCCESS,
} from './../actions/types'

const loanApplication = (state={}, {type, payload}) => {
  switch(type) {
    case LOAN_APPLICATION_FETCH_SUCCESS:
      return payload.applicationFlow.loanApplication

    case UPDATE_COMMITMENTS_SUCCESS:
    case LOAN_APPLICATION_UPDATE_SUCCESS:
    case UPDATE_READYFORFINAL_SUCCESS:
      return payload.loanApplication

    case PRIMARY_ENTERS_DATA_CHANGED:
      return { ...state, primaryEntersData: payload }

    default:
      return state
  }
}

export const getLoanApplicationPurpose = (state) => (state.purpose)
export const getLoanApplicationTarget = (state) => (state.target)
export const getLoanApplicationState = (state) => (state.state)
export const getLoanApplicationId = (state) => (state.id)
export const getRefinanceReason = (state) => (state.refinanceReason)
export const loanApplicationConditional = (state) => (state.conditional)

export default loanApplication;
